import { useState } from 'react';
import EmployeeManagementView from './EmployeeManagementView';
import PayrollConfigView from './PayrollConfigView';
import PayrollGenerationView from './PayrollGenerationView';
import PayrollReportsView from './PayrollReportsView';

const PayrollView = ({ onBack, currentUser }) => {
  const [currentSubView, setCurrentSubView] = useState('management'); // 'management', 'config', 'generation', 'reports'
  const goToMainMenu = () => onBack();

  const renderSubView = () => {
    switch (currentSubView) {
      case 'management':
        return <EmployeeManagementView onBack={goToMainMenu} currentUser={currentUser} />;
      case 'config':
        return <PayrollConfigView onBack={goToMainMenu} currentUser={currentUser} />;
      case 'generation':
        return <PayrollGenerationView onBack={goToMainMenu} currentUser={currentUser} />;
      case 'reports':
        return <PayrollReportsView onBack={goToMainMenu} currentUser={currentUser} />;
      default:
        return <EmployeeManagementView onBack={goToMainMenu} currentUser={currentUser} />;
    }
  };

  return (
    <div className="p-4 sm:p-6 bg-gradient-to-br from-gray-50 to-gray-100 min-h-screen">
      <div className="flex flex-col gap-4 md:flex-row md:justify-between md:items-center mb-6 sm:mb-8">
        <button
          onClick={onBack}
          className="flex items-center text-blue-600 hover:text-blue-800 transition duration-200 px-4 py-2 rounded-lg border border-blue-200 hover:border-blue-400 w-full md:w-auto justify-center md:justify-start"
        >
          <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          Volver al Menú Principal
        </button>
        <h1 className="text-2xl sm:text-4xl font-extrabold text-gray-900 drop-shadow-sm text-center md:text-left">Gestión de Nómina</h1>
        <div className="hidden md:block w-32"></div>
      </div>

      <div className="mb-6 flex flex-col sm:flex-row flex-wrap justify-center gap-3">
        <button
          onClick={() => setCurrentSubView('management')}
          className={`px-4 sm:px-6 py-2 rounded-lg font-semibold transition duration-200 w-full sm:w-auto ${currentSubView === 'management' ? 'bg-blue-600 text-white shadow-md' : 'bg-gray-200 text-gray-800 hover:bg-gray-300'}`}
        >
          Gestión de Empleados
        </button>
        <button
          onClick={() => setCurrentSubView('config')}
          className={`px-4 sm:px-6 py-2 rounded-lg font-semibold transition duration-200 w-full sm:w-auto ${currentSubView === 'config' ? 'bg-blue-600 text-white shadow-md' : 'bg-gray-200 text-gray-800 hover:bg-gray-300'}`}
        >
          Configuración
        </button>
        <button
          onClick={() => setCurrentSubView('generation')}
          className={`px-4 sm:px-6 py-2 rounded-lg font-semibold transition duration-200 w-full sm:w-auto ${currentSubView === 'generation' ? 'bg-blue-600 text-white shadow-md' : 'bg-gray-200 text-gray-800 hover:bg-gray-300'}`}
        >
          Generar Comprobantes
        </button>
        <button
          onClick={() => setCurrentSubView('reports')}
          className={`px-4 sm:px-6 py-2 rounded-lg font-semibold transition duration-200 w-full sm:w-auto ${currentSubView === 'reports' ? 'bg-blue-600 text-white shadow-md' : 'bg-gray-200 text-gray-800 hover:bg-gray-300'}`}
        >
          Informes
        </button>
      </div>

      {renderSubView()}
    </div>
  );
};

export default PayrollView;

